import type { AgentContextType } from "@/lib/agent-api"

const PREFIX = "it2tv:agent-composer-draft"

export type AgentComposerDraftKeyParts = {
  projectId: number
  mode: string
  contextType: AgentContextType
  contextId: number
}

/** sessionStorage key for the assistant composer of one AgentConversation. */
export function agentComposerDraftKey({ projectId, mode, contextType, contextId }: AgentComposerDraftKeyParts): string {
  return `${PREFIX}:${projectId}:${mode}:${contextType}:${contextId}`
}

export function readAgentComposerDraft(key: string): string {
  try {
    return sessionStorage.getItem(key) ?? ""
  } catch {
    return ""
  }
}

/** Empty string removes the key so storage is not cluttered with blanks. */
export function writeAgentComposerDraft(key: string, text: string): void {
  try {
    if (text === "") {
      sessionStorage.removeItem(key)
      return
    }
    sessionStorage.setItem(key, text)
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearAgentComposerDraft(key: string): void {
  try {
    sessionStorage.removeItem(key)
  } catch {
    /* ignore quota / private mode */
  }
}
